<template>
  <div class="event-intro">
    <skeleton
      class="event-intro__img"
      width="100%"
      height="100%"
      v-show="!image"
    />
    <div
      v-show="image"
      class="event-intro__img"
      :class="{'d-none d-md-block': mobileImage}"
      :style="{ backgroundImage: `url(${image})` }"
    >
    </div>
    <div
      v-show="mobileImage"
      class="event-intro__img d-md-none"
      :style="{ backgroundImage: `url(${mobileImage})` }"
    >
    </div>
    <div class="event-intro__overlay"></div>
    <div class="event-intro__content" v-show="loaded">
      <div class="container">
        <div class="event-intro__content-wrap">
          <div class="event-intro__main">
            <div class="event-intro__title">
              <slot name="title"></slot>
            </div>
            <div class="event-intro__details" v-if="$slots.details">
              <slot name="details"></slot>
            </div>
          </div>
          <div class="event-intro__actions" v-if="$slots.actions">
            <slot name="actions"></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Skeleton } from 'vue-loading-skeleton';

export default {
  name: 'Intro',
  props: {
    image: String,
    mobileImage: String,
    loaded: Boolean,
  },
  components: {
    Skeleton,
  },
};
</script>

<style lang="scss" scoped>
.event-intro {
  background-color: $color-white;
  min-height: 480px;
  display: flex;
  flex-direction: column;
  position: relative;

  &__img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    animation: fadein 0.15s;
  }

  &__overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.25) 100%);
  }

  &__content {
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.65) 50%);
    flex: 0 0 auto;
    margin-top: auto;
    color: $color-white;
    position: relative;
    z-index: 1;
  }

  &__content-wrap {
    max-width: 996px;
    margin: 0 auto;
    padding: 32px 0;
    align-items: flex-end;

    @media (min-width: breakpoint(md)) {
      display: flex;
      padding: 48px 0;
    }
  }

  &__main {
    flex: 1 1 100%;
    min-width: 0;
  }

  &__actions {
    display: inline-block;
    vertical-align: middle;
    flex: 0 0 auto;
    margin-top: 16px;

    @media (min-width: breakpoint(md)) {
      margin-left: 24px;
      margin-top: 0;
    }
  }

  &__details {
    margin-top: 16px;
    position: relative;
    overflow: hidden;
  }
}
</style>
